import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TalentHappyPathDataService } from '../../service/talent-happy-path-data-service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-talent-happy-path-header',
  standalone: false,
  templateUrl: './talent-happy-path-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './talent-happy-path-header.component.scss'
})
export class TalentHappyPathHeaderComponent implements OnInit, OnDestroy {

    @Input() jobTitle: String;
    @Input() headerText: String;
    @Input() headerOverlineText: String;
    urlHasPostingId: boolean;

    existingUser: boolean = false;

  private urlHasPostingIdSub: Subscription;
  private isGeneralApplicationSub: Subscription;

    constructor(private talentHappyPathDataService: TalentHappyPathDataService, private translateService: TranslateService) {}

    getHeaderText() {
      this.existingUser = !!(this.talentHappyPathDataService.talent && this.talentHappyPathDataService.talent.personId)
      this.talentHappyPathDataService.isGeneralApplication$.pipe(take(1)).subscribe(isGeneralApplication => {
        if (isGeneralApplication) {
          this.headerOverlineText = this.existingUser ? '':this.translateService.instant("talent-happy-path.general-application.header-overline-text");
        }
      });
      return this.headerOverlineText;
    }

    ngOnInit(): void {
      this.urlHasPostingIdSub = this.talentHappyPathDataService.urlHasPostingId$.subscribe(urlHasPostingId => {

            // When the parent component checks for a posting ID in the URL, this will be set so that we either
            // display the job title being applied to, or, if there is no posting ID, the MyAquent welcome header.

            this.urlHasPostingId = urlHasPostingId;
        });

      this.isGeneralApplicationSub = this.talentHappyPathDataService.isGeneralApplication$.subscribe(isGeneralApplication => {
        if (isGeneralApplication) {
          this.headerText = this.translateService.instant("talent-happy-path.general-application.header-text");
        }
      });
    }

    ngOnDestroy(): void {
      if (this.urlHasPostingIdSub) {
        this.urlHasPostingIdSub.unsubscribe();
      }
      if (this.isGeneralApplicationSub) {
        this.isGeneralApplicationSub.unsubscribe();
      }
    }
}
